import React, { useState, useEffect, useRef } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import "react-bootstrap-typeahead/css/Typeahead.bs5.css";

export default function SelectField({
  id,
  value,
  updateValue,
  options,
  otherParameters,
  disabled,
  multiple,
  ...others
}) {
  //#region Multiple select
  const [selectedOptions, setSelectedOptions] = useState(null);
  const typeaheadRef = useRef(null);

  const onChangeMultiple = (items) => {
    const hasItems = items && items.length > 0;
    updateValue(hasItems ? items.map((i) => i.key) : null);
    setSelectedOptions(hasItems ? items : null);
    typeaheadRef.current?.toggleMenu();
  };

  useEffect(() => {
    if (!value) setSelectedOptions(null);
  }, [value]);
  //#endregion

  //#region Single select
  const [visibleOptions, setVisibleOptions] = useState([]);
  const isValueVisibleRef = useRef(true);

  useEffect(() => {
    const optionsToShow = options.filter(
      ({ showCondition }) =>
        !showCondition || (showCondition && showCondition(otherParameters))
    );
    setVisibleOptions(optionsToShow);
  }, [options, otherParameters]);

  // Clear select value if there are no visible options
  useEffect(() => {
    if (multiple) return;
    const isValueVisible = visibleOptions.some(({ key }) => key === value);
    if (visibleOptions.length && isValueVisible !== isValueVisibleRef.current) {
      if (!isValueVisible) updateValue(visibleOptions[0].key);
      isValueVisibleRef.current = isValueVisible;
    }
  }, [visibleOptions, value, updateValue, multiple]);

  const onChangeSingle = (event) => updateValue(event.target.value);
  //#endregion

  return multiple ? (
    <Typeahead
      ref={typeaheadRef}
      id={id}
      labelKey="label"
      onChange={onChangeMultiple}
      options={options}
      placeholder="Choose a value..."
      selected={disabled || !selectedOptions ? [] : selectedOptions}
      disabled={disabled}
      multiple
      {...others}
    />
  ) : (
    <select
      className="form-select"
      aria-label="Selector value"
      id={id}
      onChange={onChangeSingle}
      value={value}
      disabled={disabled}
      {...others}
    >
      {visibleOptions.map(({ key, label }) => (
        <option value={key} key={`option-${id}-${key}`}>
          {label}
        </option>
      ))}
    </select>
  );
}
